import { useConnectionReservationsWithUsers } from "@lib/store/src/ui/hooks/timeslots/useConnectionReservationsWithUsers";
import { dateToLocalDateString } from "@lib/store/src/data/timeslots/dateTimeHelpers";

/** Connections' bookings in an area on the day of `now`, with who made them, in the order they start. */
export const useAreaConnections = ({ areaId, now }: { areaId: string; now: Date }) => {
  return useConnectionReservationsWithUsers(dateToLocalDateString(now)).filter(({ reservation }) => {
    return "areaId" in reservation.workspace && reservation.workspace.areaId === areaId;
  });
};
